import config from '../../../config';


export const PLATFORM_LANGUAGE_DEFAULT = config.locale.defaultLanguageTag;

export const PLATFORM_LOCALE_TAG_DEFAULT = config.locale.defaultLocaleTag;

export const PLATFORM_LOCALES = config.locale.available;

export const PLATFORM_LOCALE_TAGS = PLATFORM_LOCALES.map(({tag}) => tag);
